"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = exports.OrderType = void 0;
var OrderType;
exports.OrderType = OrderType;
(function (OrderType) {
  OrderType["LIMIT"] = "LIMIT";
  OrderType["MARKET"] = "MARKET";
  OrderType["POST_ONLY"] = "POST_ONLY";
  OrderType["PREVIOUSLY_QUOTED"] = "PREVIOUSLY_QUOTED";
  OrderType["STOP_LIMIT"] = "STOP_LIMIT";
  OrderType["STOP_LOSS"] = "STOP_LOSS";
})(OrderType || (exports.OrderType = OrderType = {}));
var _default = OrderType;
exports.default = _default;